import { Component, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as fromShared from '../../shared';
import * as fromDataServices from '../../data-services';
import { VendorModel } from '../../data-services/vendor';
import { ReplaySubject } from 'rxjs';
import { DisplayErrors } from '../../shared/errors-sidenav';

@Component({
    selector: 'ef-vendor-presenter',
    templateUrl: './vendor-presenter.component.html',
    styleUrls: ['./vendor-presenter.component.scss'],
    standalone: false
})
export class VendorPresenterComponent
extends fromShared.EditGrid<fromDataServices.Vendor.VendorModel>
    implements OnInit
{
    numCols = 5;

    @ViewChild(fromShared.Table, { static: true })
    dataTable: fromShared.Table;

    @Input() employeesSelectItem: fromShared.SelectItem[];

    @Output() SaveVendor = new ReplaySubject<VendorModel>(1);
    @Output() GetVendor = new ReplaySubject<any>(1);

    only1099 = false;
    matchOnName = false;

    vendorFilterSelectItem: fromShared.SelectItem[] = [];

    clonedVendors: VendorModel[] = [];
    loadClone = true;
    rowData: VendorModel;

    private VendorSubject = new ReplaySubject<Array<VendorModel>>(1);
    private _vendors: Array<VendorModel>;
    @Input() set vendors(value: Array<VendorModel>) {
        this._vendors = value;
        this.VendorSubject.next(value);

        if (value && value.length > 0) {

            if (this.loadClone == true) {
                this.clonedVendors = value;
                this.loadClone = false;
            } else {
                if (this.rowData != null) {
                    if (value.some(x => x.Status.StatusCode == 3) == true) {
                        this.rowData.Status = {
                            StatusCode: fromShared.ResponseStatus.Error,
                            Message: 'Update Failed'
                        };
                    } else {
                        this.rowData.Status = {
                            StatusCode: fromShared.ResponseStatus.Success,
                            Message: 'Success'
                        };
                    }
                }
            }

            this.vendorFilterSelectItem = value.map(x => ({
                label: x.VendorName,
                value: x.VendorListID
            }));
        }
    }
    get vendors(): Array<VendorModel> {
        return this._vendors;
    }

    constructor() {
        super();
    }

    ngOnInit(): void {}

    onConTimeChange($event, rowData) {

        this.rowData = rowData;

        this.SaveVendor.next({
            ...rowData,
            ConTime: $event
        });
    }
    onConExpChange($event, rowData) {

        this.rowData = rowData;

        this.SaveVendor.next({
            ...rowData,
            ConExp: $event
        });
    }
    onEmployeeChange($event, rowData) {

        this.rowData = rowData;

        const selectedOption =
            this.employeesSelectItem.find(x => x.value == $event.value) != null
                ? this.employeesSelectItem.find(x => x.value == $event.value)
                : { label: '', value: '' };

        this.SaveVendor.next({
            ...rowData,
            EmployeeListID: selectedOption.value,
            EmployeeName: selectedOption.label
        });
    }

    onOnly1099FilterChange($event) {
        this.loadClone = true;
        this.GetVendor.next({
            Only1099: $event,
            MatchOnName: this.matchOnName
        });
    }

    onMatchOnNameFilterChange($event) {
        this.loadClone = true;
        this.GetVendor.next({ Only1099: this.only1099, MatchOnName: $event });
    }

    filterTable($event) {
        // use this for all table filters
        this.dataTable.filter($event.value, 'VendorListID', 'in');
    }
}
